module.exports = __webpack_public_path__ + "img/PtownFlags_Verticle_1.a0ffde24.png";